import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MyMapBoxDirection from "../components/MyMapBoxDirection";
import locationsSelector from "../selectors/locationsSelector";
import colorsSelector from "../selectors/colorsSelector";

const DirectionsContainer = (props) => {
  const { coords, colors, fleetIds } = props;

  return (
    <MyMapBoxDirection fleetIds={fleetIds} coords={coords} colors={colors} />
  );
};

DirectionsContainer.propTypes = {
  colors: PropTypes.object.isRequired,
  coords: PropTypes.object.isRequired,
  fleetIds: PropTypes.array.isRequired,
};

function mapStateToProps(state) {
  const locations = locationsSelector(state);
  const colors = colorsSelector(locations);
  const coords = state.directionReducer.data || {};
  return {
    colors,
    coords,
  };
}

export default connect(mapStateToProps)(DirectionsContainer);
